@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.wrapper {
  position: relative;
  width: 350px;
  height: 350px;
}

.chartContainer {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.svg {
  width: 100%;
  height: 100%;
}

.arc {
  stroke: white;
  stroke-width: 2;
  stroke-linejoin: round;
  cursor: pointer;
}

.label {
  text-anchor: middle;
  dominant-baseline: middle;
  font-weight: 500;
  color: var(--dark-80);
  cursor: pointer;
  font-size: var(--fontSize);
}

.legendText {
  font-size: 12px;
  fill: var(--dark-80);
}

.tooltip {
  position: absolute;
  pointer-events: none;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 8px;
  z-index: 10;
}

.tooltipContent {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: var(--dark-80);

  span:last-child {
    font-weight: 500;
  }
}
